/** Build-time settings handed to the client through a JSON block in the page. */

export interface ConsoleConfig {
  basePath: string;
  docsBase: string;
  authApiBase: string;
  accountsApiBase: string;
  streamsApiBase: string;
  accountsAppBase: string;
  streamsAppBase: string;
  loginUrl: string;
  logoutUrl: string;
  tokenKey: string;
}

let cached: ConsoleConfig | null = null;

export function consoleConfig(): ConsoleConfig {
  if (cached) return cached;

  const node = document.getElementById('console-config');
  if (!node?.textContent) {
    throw new Error('console-config block missing — the page was not generated as a console page.');
  }

  cached = JSON.parse(node.textContent) as ConsoleConfig;
  return cached;
}

/** Trailing-slash console URL for a sub-route, e.g. route('apps') → "/console/apps/". */
export function route(path = ''): string {
  const base = consoleConfig().basePath.replace(/\/+$/, '');
  const clean = path.replace(/^\/+|\/+$/g, '');
  return clean ? `${base}/${clean}/` : `${base}/`;
}
